import styled from 'styled-components';

import { flexBetween, flexColumn } from '@/styles/common';

const TRANSITION_ANIMATION = `linear 0.2s`;

export const Wrapper = styled.div`
  ${flexColumn};
`;

export const Header = styled.div<{ $isOpen: boolean }>`
  ${flexBetween};
  flex-wrap: nowrap;
  padding-block: 5px;

  &:hover {
    cursor: pointer;
  }

  & > svg {
    color: var(--border-main);
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(0)' : 'rotate(-90deg)')};
    transition: transform ${TRANSITION_ANIMATION};
  }
`;

export const ContentWrapper = styled.div<{ $isOpen: boolean; $height: number }>`
  margin-top: 25px;
  margin-bottom: ${({ $isOpen }) => ($isOpen ? '24px' : '0px')};

  height: ${({ $isOpen, $height }) => {
    const computedHeight = $height ? `${$height}px` : 'auto';
    return $isOpen ? computedHeight : '0px';
  }};

  overflow: hidden;
  transition: all ${TRANSITION_ANIMATION};
`;
